/** @jsxRuntime classic */
/** @jsx jsx */
/** @jsxFrag React.Fragment */
import { css, jsx } from "@emotion/react";
import { IconButton, Tooltip } from "@material-ui/core";
import { useI18n } from "hooks/i18n/i18n";
import React from "react";
import { useAnalyticsOptional } from "utility/ga/AnalyticsContext";

type WatchlistIconButtonProps = {
  isWatched: boolean;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
};

const watchlistOnIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.0002 24.9083L12.3085 23.3683C6.30016 17.92 2.3335 14.3267 2.3335 9.91667C2.3335 6.32333 5.15683 3.5 8.75016 3.5C10.7802 3.5 12.7285 4.445 14.0002 5.93833C15.2718 4.445 17.2202 3.5 19.2502 3.5C22.8435 3.5 25.6668 6.32333 25.6668 9.91667C25.6668 14.3267 21.7002 17.92 15.6918 23.38L14.0002 24.9083Z"
      fill="#00C2AD"
    />
  </svg>
);

const watchlistOffIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.2502 0.5C15.2202 0.5 13.2718 1.445 12.0002 2.93833C10.7285 1.445 8.78016 0.5 6.75016 0.5C3.15683 0.5 0.333496 3.32333 0.333496 6.91667C0.333496 11.3267 4.30016 14.92 10.3085 20.38L12.0002 21.9083L13.6918 20.3683C19.7002 14.92 23.6668 11.3267 23.6668 6.91667C23.6668 3.32333 20.8435 0.5 17.2502 0.5ZM12.1168 18.6417L12.0002 18.7583L11.8835 18.6417C6.33016 13.6133 2.66683 10.2883 2.66683 6.91667C2.66683 4.58333 4.41683 2.83333 6.75016 2.83333C8.54683 2.83333 10.2968 3.98833 10.9152 5.58667H13.0968C13.7035 3.98833 15.4535 2.83333 17.2502 2.83333C19.5835 2.83333 21.3335 4.58333 21.3335 6.91667C21.3335 10.2883 17.6702 13.6133 12.1168 18.6417Z"
      fill="#D6D6D6"
    />
  </svg>
);

const buttonStyle = css`
  padding: 8px;
`;

export const WatchlistIconButton: React.FC<WatchlistIconButtonProps> = ({
  isWatched,
  onClick,
}) => {
  const { t } = useI18n();
  const analytics = useAnalyticsOptional();

  const handleClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    // Fire analytics event when adding to watchlist (when not currently watched)
    if (!isWatched && analytics) {
      analytics.sendEvent("add_to_wishlist");
    }

    // Call the original onClick handler
    onClick(e);
  };

  return (
    <Tooltip title={t("goods.watchlist.buttonHelp")}>
      <IconButton onClick={handleClick} css={buttonStyle}>
        {isWatched ? watchlistOnIcon() : watchlistOffIcon()}
      </IconButton>
    </Tooltip>
  );
};
